import { createBrowserRouter, Navigate } from 'react-router';
import { RootLayout } from './layouts/RootLayout';
import { RouteErrorFallback } from './components/RouteErrorFallback';
import ConfirmationPage from './features/reservation/pages/ConfirmationPage';

const hydrateFallbackElement = (
  <div className="flex min-h-screen items-center justify-center text-gray-500">
    Se incarca...
  </div>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    hydrateFallbackElement,
    errorElement: <RouteErrorFallback />,
    children: [
      {
        index: true,
        lazy: () => import('./features/reservation/pages/ReservationPage'),
      },
      {
        path: 'tip-bilet',
        lazy: () => import('./features/reservation/pages/TicketTypePage'),
      },
      {
        path: 'contact',
        lazy: () => import('./features/reservation/pages/ContactPage'),
      },
      {
        path: 'confirmare',
        element: <ConfirmationPage />,
      },
      {
        path: 'cont',
        lazy: () => import('./features/reservation/pages/AccountPage'),
      },
      {
        path: 'verifica-bilet',
        lazy: () => import('./features/reservation/pages/VerifyTicketPage'),
      },
    ],
  },
  {
    path: '/admin/login',
    hydrateFallbackElement,
    errorElement: <RouteErrorFallback />,
    lazy: () => import('./features/admin/pages/LoginPage'),
  },
  {
    path: '/admin',
    hydrateFallbackElement,
    errorElement: <RouteErrorFallback />,
    lazy: () => import('./features/admin/layouts/AdminLayout'),
    children: [
      {
        index: true,
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/DashboardPage'),
      },
      {
        path: 'tari',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/CountriesPage'),
      },
      {
        path: 'statii',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/StationsPage'),
      },
      {
        path: 'plecari',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/RoutesPage'),
      },
      {
        path: 'autocare',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/BusesPage'),
      },
      {
        path: 'preturi',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/DeparturesPage'),
      },
      {
        path: 'lista_plecari',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/DeparturesListPage'),
      },
      {
        path: 'rute',
        element: <Navigate to="/admin/plecari" replace />,
      },
      {
        path: 'rezervari',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/ReservationsPage'),
      },
      {
        path: 'vanzari',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/SalesPage'),
      },
      {
        path: 'comisioane',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/CommissionsPage'),
      },
      {
        path: 'utilizatori',
        errorElement: <RouteErrorFallback />,
        lazy: () => import('./features/admin/pages/UsersPage'),
      },
    ],
  },
]);
